<template>
  <div style="width: 100%">
    <div class="text-center" style="width: 100%">
      <button class="card-tarja-btn" @click="handleClick" :disabled="isButtonDisabled">
        <v-icon>mdi-qrcode</v-icon>
        <span>QR Code</span>
      </button>
    </div>

    <ModalConfirmAction
      :visible="showDialog"
      title="Exibir QRCODE da enquete na tarja"
      message="Tem certeza que deseja exibir o QRCODE da enquete na tarja?"
      confirm-text="Exibir"
      confirm-color="primary"
      :loading="loadingTarja"
      @confirm="confirmExibir"
      @cancel="showDialog = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { apiClient } from "@/services/api";
import { isSporTVProduction } from "@/config/enqueteComponentMap";
import ModalConfirmAction from "@/components/Modal/ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    codProducao: Number,
    id_enquete: Number,
    isDisabled: Boolean,
    enqueteItem: Object,
    hasModeAvailable: Boolean,
  },
  data() {
    return {
      loadingTarja: false,
      showDialog: false,
      exibirModalConfirmacao: null,
      latestCodProducaoRequest: null,
    };
  },
  async created() {
    if (this.codProducao) {
      await this.getConfigTarja({ cod_producao: this.codProducao });
      this.exibirModalConfirmacao = this.configTarja?.flg_botao_confirmar_exibicao;
    }
  },
  computed: {
    ...mapGetters({
      configTarja: "tarja_enquete/getConfigTarja",
    }),
    enqueteData() {
      return this.enqueteItem || null;
    },
    qrCodeUrl() {
      return this.enqueteData?.enquete_qr_code?.url || null;
    },
    hasQRCode() {
      return this.qrCodeUrl && this.qrCodeUrl.trim() !== '';
    },
    isCombinedModeEnabled() {
      const selectedProducao = this.$store.state.producoes.selectedProducao;
      return selectedProducao?.settings?.enquete?.qr_code_combined ?? false;
    },
    isButtonDisabled() {
      return this.isDisabled || !this.hasQRCode || !this.hasModeAvailable;
    },
    disabledTooltipMessage() {
      if (!this.hasModeAvailable) {
        return 'Modo QR Code não disponível para esta produção';
      }
      if (!this.hasQRCode) {
        return 'Esta enquete não possui QR Code';
      }
      return 'Clique para exibir QR Code da enquete';
    },
  },
  methods: {
    ...mapActions({
      getConfigTarja: "tarja_enquete/getConfigTarjaEnquete",
      updateEnqueteQrCodeFlag: "enquetes/updateEnqueteQrCodeFlag",
      setQRCodeMode: "producoes/setQRCodeMode",
    }),
    handleClick() {
      if (this.exibirModalConfirmacao) {
        this.showDialog = true;
      } else {
        this.setEnqueteTarjaQRCode();
      }
    },
    confirmExibir() {
      this.setEnqueteTarjaQRCode();
    },
    async setEnqueteTarjaQRCode() {
      if (!this.configTarja) {
        this.$toast.warning(
          "Nenhuma configuração de tarja definida! Por favor, crie uma."
        );
        return;
      }

      if (!this.hasQRCode) {
        this.$toast.warning("Esta enquete não possui QR Code");
        return;
      }

      this.loadingTarja = true;

      try {
        const useCombinedMode = this.isCombinedModeEnabled;

        await this.setQRCodeMode({
          enabled: true,
          combined: useCombinedMode,
          tarjaMode: false,
        });

        await this.updateEnqueteQrCodeFlag({
          cod_producao: this.codProducao,
          qr_code: true,
          qr_code_combined: useCombinedMode,
          tarja_mode: false,
        });

        if (useCombinedMode && !isSporTVProduction(this.codProducao)) {
          await apiClient.patch(`/producao/${this.codProducao}/flag-exibir-resultado`, {
            exibir_resultado: false,
          });
        }

        await apiClient.patch(
          `atualizarFlgIsFullScreenTarjaEnquete/${this.configTarja.id}/${this.codProducao}`,
          {
            flg_is_fullscreen: false,
            flg_qrcode_mode: false,
          }
        );

        await this.getConfigTarja({ cod_producao: this.codProducao });

        this.$emit("change");

        this.$emit("force-refresh");

        setTimeout(() => {
          this.showDialog = false;
        }, 250);
      } catch (error) {
        console.error("Error setting QR Code mode:", error);
        this.$toast.error(
          "Erro ao configurar QR Code na tarja: " +
            (error.response?.data?.message || error.message || "Erro desconhecido")
        );
      } finally {
        this.loadingTarja = false;
      }
    },
  },
  watch: {
    "$store.state.tarja_enquete.configTarjaEnquete": function (newValue) {
      this.exibirModalConfirmacao = newValue?.flg_botao_confirmar_exibicao;
    },
    codProducao: {
      async handler(value) {
        if (!value) return;

        const requestId = Date.now();
        this.latestCodProducaoRequest = requestId;

        try {
          await this.getConfigTarja({ cod_producao: value });

          if (this.latestCodProducaoRequest === requestId) {
            this.exibirModalConfirmacao = this.configTarja?.flg_botao_confirmar_exibicao;
          }
        } catch (error) {
          console.error("Error fetching config tarja:", error);
        }
      },
      immediate: false,
    },
  },
};
</script>

